import { render, staticRenderFns } from "./Pricing-1.vue?vue&type=template&id=b0690136&"
import script from "./Pricing-1.vue?vue&type=script&lang=js&"
export * from "./Pricing-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports